export const CUSTOMKEY = 'customDate';

// | 'currentMonth';